<template>
  <div class="trucks-list-index">
    <div class="listsearch-exhibition" v-if="tags.some((row) => row.label)">
      <div class="search-field-list">当前搜索</div>
      <el-tag
        v-show="tag.label"
        class="eltag-padding"
        v-for="tag in tags"
        :key="tag.name"
        closable
        :type="tag.type"
        @close="closeTag(tag)"
      >
        {{ tag.name }}:{{ tag.label }}
      </el-tag>
      <div class="eliminate-search" @click="closeAllTags">清除所有</div>
    </div>
    <!-- 搜索 -->
    <div class="search-head">
      <div class="search-display-flex">
        <div class="search-name">车辆状态</div>
        <div
          class="name-margin"
          v-for="(item, index) in truckstatelist"
          :key="index"
          @click="searchChange(item.val, item.name, 0, 'truckstate')"
          :class="{ active: item.name == queryParams.truckstate }"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="el-button display-naniu">
        <span>更多</span>
        <span class="el-icon--right el-icon-arrow-down"></span>
      </div>
    </div>
    <div class="search-head boder-top">
      <div class="search-display-flex">
        <div class="search-name">车辆型号</div>
        <div
          class="name-margin"
          v-for="(item, index) in tklxs"
          :key="index"
          @click="searchChange(item.id, item.name, 1, 'tktpid')"
          :class="{ active: item.name == queryParams.tktpid }"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="el-button display-naniu">
        <span>更多</span>
        <span class="el-icon--right el-icon-arrow-down"></span>
      </div>
    </div>
    <div class="search-head boder-top">
      <div class="search-display-flex">
        <div class="search-name">车辆长度</div>
        <div class="search-length-flex">
          <div
            class="length-display"
            :style="{ height: isShowclcd ? 'auto' : '25px' }"
          >
            <div
              class="name-margin width-fontzhanshi"
              v-for="(item, index) in tklens"
              :key="index"
              @click="searchChange(item.id, item.name, 2, 'tklenid')"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="el-button display-naniu" @click="isShowclcd = !isShowclcd">
          <span>更多</span>
          <span
            v-if="!isShowclcd"
            class="el-icon--right el-icon-arrow-down"
          ></span>
          <span v-else class="el-icon--right el-icon-arrow-up"></span>
        </div>
      </div>
    </div>
    <div class="middle-search">
      <div class="zonghe-paixu" @click="zhhandleReset">综合排序</div>
      <div class="middle-search-flex">
        <el-form
          class="zixunliebiao-query-form"
          size="small"
          ref="queryForm"
          :inline="true"
          :model="queryParams"
          label-width="0"
        >
          <div class="search-flex">
            <div class="search-Price Price-hover" @click="sortChange(1)">
              <span class="Price-font">价格</span>
              <span class="caret-wrapper">
                <i
                  class="el-icon-caret-top caret-position"
                  :class="{
                    active: queryParams.sortField == 1 && queryParams.sort == 1,
                  }"
                ></i>
                <i
                  class="el-icon-caret-bottom caret-positionX"
                  :class="{
                    active: queryParams.sortField == 1 && queryParams.sort == 2,
                  }"
                ></i>
              </span>
            </div>
            <div class="search-Price Price-hover" @click="sortChange(2)">
              <span class="Price-font">人气</span>
              <span class="caret-wrapper">
                <i
                  class="el-icon-caret-top caret-position"
                  :class="{
                    active: queryParams.sortField == 2 && queryParams.sort == 1,
                  }"
                ></i>
                <i
                  class="el-icon-caret-bottom caret-positionX"
                  :class="{
                    active: queryParams.sortField == 2 && queryParams.sort == 2,
                  }"
                ></i>
              </span>
            </div>
            <div class="search-Price right-width">
              <el-input
                class="search-input"
                v-model="queryParams.startprice"
                placeholder="￥最底价"
              ></el-input>
              <span class="margin-text">-</span>
              <el-input
                class="search-input"
                v-model="queryParams.endprice"
                placeholder="￥最高价"
              ></el-input>
            </div>
            <div class="search-Price right-width">
              <el-input
                class="search-input"
                v-model="queryParams.fhregion"
                placeholder="装货地"
              ></el-input>
              <span class="margin-text">-</span>
              <el-input
                class="search-input"
                v-model="queryParams.shregion"
                placeholder="卸货地"
              ></el-input>
            </div>
            <div class="search-Price right-width">
              <el-input
                class="search-input"
                v-model="queryParams.carnumber"
                placeholder="车牌号"
              ></el-input>
            </div>
            <div class="search-Price-wu">
              <div class="el-button display-Reset" @click="handleReset">
                重置
              </div>
              <div class="el-button display-determine" @click="handleQuery()">
                确定
              </div>
            </div>
          </div>
        </el-form>
        <div class="span-xinxi">
          共找到
          <span class="color-green">
            <span>{{ count }}</span> 条</span
          >
          车源
        </div>
      </div>
    </div>
    <div class="goods-content">
      <el-empty description="暂无数据" v-if="list.length == 0"></el-empty>
      <!-- 车源列表 -->
      <div class="middle-box">
        <div
          class="middle-huoyuan-zhanshi"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="address-zhanshi">
            {{ item.depregion }} <span>--</span> {{ item.destregion }}
          </div>
          <div class="text-information-zhanshi">
            <div class="text-information">
              发布日期：<span class="font-color-black">{{ item.regdt }}</span>
            </div>
            <div class="text-information">
              <span>{{ item.hits }}</span> 人看过
            </div>
          </div>
          <div class="text-information-zhanshi">
            <div class="text-information">
              车牌号码：<span class="font-color-black">{{
                item.carnumber
              }}</span>
            </div>
            <div class="text-state" v-if="item.shipyq == 2">整车</div>
            <div class="text-state-green" v-if="item.shipyq == 1">拼车</div>
            <div class="text-state-blue" v-if="item.shipyq == 3">零担</div>
          </div>
          <div class="text-information-zhanshi">
            <div class="text-information">
              车辆类型：<span class="font-color-black">{{
                item.trucklen
              }}</span>
            </div>
            <div class="text-information">{{ item.trucktype }}</div>
          </div>
          <div class="text-information-zhanshi">
            <div class="text-information">
              运费报价：<span class="font-color-black"
                >¥ <span>{{ item.yfprice }}</span> /吨</span
              >
            </div>
          </div>
          <div class="button-information-zhanshi">
            <div class="text-information">
              有效期：<span class="font-color-black">{{
                item.showeffectname
              }}</span>
            </div>
            <el-button type="warning" plain @click="handleEdit(item)"
              >查看详情</el-button
            >
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="zixunliebiao-pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="queryParams.pageNum"
          :page-sizes="[15, 30, 45, 55, 100, 200]"
          :page-size="queryParams.count"
          layout="total, prev, pager, next, sizes"
          :total="count"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import services from '@/services/index'
export default {
  data () {
    return {
      isShowclcd: false,
      goodttaglist: [],
      truckstatelist: [],
      trucktypes: [],
      tklxs: [],
      tklens: [],
      list: [],
      count: 0,
      current: 1,
      queryParams: {
        truckstate: '',
        tklenid: '',
        tktpid: '',
        fhregion: '',
        shregion: '',
        startprice: '',
        carnumber: '',
        sortField: '',
        endprice: '',
        sort: '',
        pageNum: 1,
        limit: 0,
        count: 15
      },
      tags: [
        { name: '车辆状态', type: '', label: '', key: 'truckstate' },
        { name: '车辆型号', type: '', label: '', key: 'tktpid' },
        { name: '车辆长度', type: '', label: '', key: 'tklenid' }
      ]
    }
  },
  created: function () {
    this.getInit()
    this.getTKSrcCenterList()
  },
  methods: {
    // 查看详情
    handleEdit (row) {
      this.$router.push({ path: '/tkdetail/' + row.id })
    },
    // 头部搜索
    searchChange (value, name, index, key) {
      this.queryParams[key] = value
      this.tags[index].label = name
      this.handleQuery()
    },
    closeTag (tag) {
      tag.label = ''
      this.queryParams[tag.key] = ''
      this.handleQuery()
    },
    // 头部重置
    closeAllTags () {
      this.tags.map(row => {
        row.label = ''
        return row
      })
      this.queryParams.tktpid = ''
      this.queryParams.truckstate = ''
      this.queryParams.tklenid = ''
      this.handleQuery()
    },
    // 综合排序重置
    zhhandleReset () {
      this.queryParams.startprice = ''
      this.queryParams.endprice = ''
      this.queryParams.fhregion = ''
      this.queryParams.shregion = ''
      this.queryParams.sortField = ''
      this.queryParams.sort = ''
      this.handleReset()
    },
    // 价格 人气搜索
    sortChange (sortField) {
      this.queryParams.sortField = sortField
      this.queryParams.sort = this.queryParams.sort === 2 || !this.queryParams.sort ? 1 : 2
      this.handleQuery()
    },
    // 搜索
    handleQuery () {
      this.queryParams.pageNum = 1
      this.queryParams.limit = 0
      this.getTKSrcCenterList()
    },
    // 重置
    handleReset () {
      this.queryParams.startprice = ''
      this.queryParams.endprice = ''
      this.queryParams.fhregion = ''
      this.queryParams.shregion = ''
      this.queryParams.carnumber = ''
      this.handleQuery()
    },
    // 每页多少条
    handleSizeChange (val) {
      window.scrollTo(0, 0)
      this.queryParams.count = val
      this.getTKSrcCenterList()
    },
    // 当前页
    handleCurrentChange (val) {
      window.scrollTo(0, 0)
      this.queryParams.pageNum = val
      this.queryParams.limit = (val - 1) * this.queryParams.count
      this.getTKSrcCenterList()
    },
    // 获取初始化信息
    getInit () {
      const that = this
      services.TrucksList.getInit().then(function (res) {
        that.goodttaglist = res.info.goodttaglist || []
        that.truckstatelist = res.info.truckstatelist || []
        that.tklxs = res.info.tklxs || []
        that.tklens = res.info.tklens || []
      })
    },
    // 获取货源中心列表
    getTKSrcCenterList () {
      const that = this
      services.TrucksList.getTKSrcCenterList(that.queryParams).then(function (res) {
        that.list = res.info.list || []
        that.count = Number(res.info.count)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.trucks-list-index {
  width: 1190px;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 40px;
  .listsearch-exhibition {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .search-field-list {
      font-size: 13px;
      color: #9b9b9b;
      margin-right: 10px;
    }
    .eliminate-search {
      font-size: 13px;
      color: #9b9b9b;
      margin-left: 5px;
    }
    .eliminate-search:hover {
      color: #32b16c;
      cursor: pointer;
    }
    .eltag-padding {
      margin-right: 10px;
    }
  }
  * {
    box-sizing: border-box;
  }
  .goods-content {
    .zixunliebiao-pagination-box {
      text-align: center;
      margin-top: 30px;
    }
  }
  .search-head {
    width: 100%;
    background-color: #f8f8f8;
    border: 1px solid #cecece;
    overflow: hidden;
  }
}
.trucks-list-index {
  width: 1190px;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 40px;
  * {
    box-sizing: border-box;
  }
  // .goods-content {
  //   height: 500px;
  // }
  .search-head {
    width: 100%;
    line-height: 50px;
    background-color: #f8f8f8;
    border: 1px solid #cecece;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 20px;
    font-size: 12px;
    .search-display-flex {
      display: flex;
      align-items: flex-start;
      .search-length-flex {
        display: flex;
        align-items: center;
        .length-display {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
        }
      }
    }
    .search-name {
      color: #9b9b9b;
      margin-right: 20px;
      width: 90px;
      flex-shrink: 0;
    }
    .name-margin {
      margin-right: 40px;
      color: #303133;
      cursor: pointer;
    }
    .width-fontzhanshi {
      width: 130px;
    }
    .name-margin:hover,
    .name-margin.active {
      color: #32b16c;
    }
    .display-naniu {
      width: 90px;
      padding: 6px 8px;
      font-size: 12px;
      flex-shrink: 0;
      margin-top: 12px;
      .search-display-flex {
        display: flex;
        align-items: center;
      }
      .search-name {
        color: #9b9b9b;
        margin-right: 20px;
        width: 90px;
      }
      .name-margin {
        margin-right: 40px;
        color: #303133;
        cursor: pointer;
      }
      .width-fontzhanshi {
        width: 120px;
      }
      .search-length-flex {
        display: flex;
        align-items: center;
      }
      .name-margin:hover {
        color: #32b16c;
      }
      .display-naniu {
        width: 90px;
        padding: 6px 8px;
        font-size: 12px;
        color: #9b9b9b;
      }
      color: #9b9b9b;
    }
  }
  .boder-top {
    border-top: 0;
  }
  .middle-search {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .zonghe-paixu {
      width: 88px;
      height: 49px;
      line-height: 49px;
      text-align: center;
      border: 1px solid #cecece;
      border-right: 0;
      font-size: 12px;
      cursor: pointer;
    }
    .zonghe-paixu:hover {
      color: #32b16c;
    }
    .middle-search-flex {
      .span-xinxi {
        line-height: 49px;
      }
      .search-flex {
        display: flex;
        align-items: center;
        .Price-hover:hover {
          color: #32b16c;
          cursor: pointer;
        }
        .caret-wrapper {
          position: relative;
          i.active {
            color: #32b16c;
          }
        }
        .caret-position {
          color: #000;
          position: absolute;
          right: -14px;
          top: -1px;
        }
        .caret-positionX {
          color: #000;
          position: absolute;
          right: -14px;
          top: 5px;
        }
        .search-Price-wu {
          .display-Reset {
            width: 75px;
            padding: 6px 8px;
            font-size: 12px;
          }
          .display-determine {
            width: 75px;
            padding: 6px 8px;
            font-size: 12px;
            border: 1px solid #ffa633;
            color: #ffa633;
          }
          .display-determine:hover {
            background-color: #fff4e7;
          }
        }
      }
      width: 100%;
      height: 49px;
      line-height: 47px;
      display: flex;
      text-align: center;
      justify-content: space-between;
      border: 1px solid #cecece;
      font-size: 12px;
      background-color: #f8f8f8;
      padding: 0 20px;
      .search-Price {
        border-right: 1px solid #cecece;
        padding-right: 27px;
        margin-right: 15px;
        .search-input {
          width: 88px;
        }
        ::v-deep.el-input__inner {
          height: 25px;
          line-height: 25px;
        }
        .margin-text {
          margin-left: 10px;
          margin-right: 10px;
        }
      }
      .right-width {
        padding-right: 15px;
      }
    }
    .color-green {
      color: #32b16c;
    }
  }
  .middle-box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .middle-huoyuan-zhanshi {
    width: 385px;
    height: 228px;
    background-color: #f8f8f8;
    border-radius: 4px;
    padding: 15px 20px;
    margin-top: 17.5px;
    margin-right: 17.5px;
    &:nth-child(3n) {
      margin-right: 0;
    }
    .address-zhanshi {
      font-size: 15px;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .text-information-zhanshi {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      .text-information {
        color: #9b9b9b;
        font-size: 14px;
      }
      .font-color-black {
        color: #000;
      }
      .text-state {
        width: 35px;
        height: 18px;
        line-height: 18px;
        background: #ffa633;
        color: #fff;
        border-radius: 2px;
        font-size: 14px;
        text-align: center;
      }
      .text-state-green {
        width: 35px;
        height: 18px;
        line-height: 18px;
        background: #32b16c;
        color: #fff;
        border-radius: 2px;
        font-size: 14px;
        text-align: center;
      }
      .text-state-blue {
        width: 35px;
        height: 18px;
        line-height: 18px;
        background: #33a0ff;
        color: #fff;
        border-radius: 2px;
        font-size: 14px;
        text-align: center;
      }
    }
    .button-information-zhanshi {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .text-information {
        color: #9b9b9b;
        font-size: 14px;
      }
      .font-color-black {
        color: #000;
      }
    }
  }
}
</style>
